import { Injectable } from '@angular/core';
import { Router, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from '@angular/router';
import {AuthenticationService} from '../_services/authentication.service';


@Injectable({ providedIn: 'root' })
export class AuthGuard  {

  constructor(private router: Router, private authenticationService: AuthenticationService) { }

  // canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
  //     if (localStorage.getItem('currentUser')) {
  //         // logged in so return true
  //         return true;
  //     }
  //
  //     // not logged in so redirect to login page with the return url
  //     this.router.navigate(['/authentication/login'], {queryParams: { returnUrl: state.url }});
  //     return false;
  // }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | UrlTree | Promise<boolean | UrlTree> {
    if (localStorage.getItem('currentUser')) {
      if (sessionStorage.getItem('gotMe') === null || sessionStorage.getItem('gotMe') === undefined) {
        const promise = new Promise<boolean | UrlTree>((resolve, reject) => {
          this.authenticationService.getMe().pipe().subscribe(user => {
            console.log('user guard', user);
            if (user.deleted || user.disabled) {
              console.log('User was invalid, returning to signin.');
              localStorage.removeItem('currentUser');
              // Return a UrlTree instead of calling router.navigate() here - navigating
              // imperatively from inside a guard can be dropped by the router when it
              // conflicts with the in-flight navigation, leaving a blank page.
              return resolve(this.router.createUrlTree(['/session/login'], { queryParams: { returnUrl: state.url } }));

            }
            else {
              localStorage.setItem('currentUser', JSON.stringify(user));
              sessionStorage.setItem('gotMe', 'true');
              return resolve(true);
            }
          }, error => {
            console.log(error);
            localStorage.removeItem('currentUser');
            return resolve(this.router.createUrlTree(['/session/login'], { queryParams: { returnUrl: state.url } }));

          });
        });
        return promise;
      }
      else {
        return true;
      }
    }
    else {
      return this.router.createUrlTree(['/session/login'], { queryParams: { returnUrl: state.url } });
    }
  }

}
